import React from "react";

export default function ProgressTracker({
  steps,
  completedMap = {},
  activeIndex = null,
}) {
  return (
    <div className="flex flex-wrap gap-3">
      {steps.map((step, index) => {
        const completed = Boolean(completedMap[step.key]);
        const isActive = activeIndex === index;
        const baseClasses = completed
          ? "bg-amber-500 text-white"
          : isActive
          ? "bg-amber-100 text-amber-700"
          : "bg-slate-100 text-slate-600";

        return (
          <div key={step.key} className="flex items-center gap-2">
            <span
              className={`flex h-6 w-6 items-center justify-center rounded-full text-xs ${baseClasses}`}
            >
              {index + 1}
            </span>
            <span className="text-xs text-slate-600">{step.label}</span>
          </div>
        );
      })}
    </div>
  );
}
